import { getMap } from '@/lib/map/instance';
import mapboxgl from 'mapbox-gl';

export interface LatLng {
  lat: number;
  lng: number;
}

/**
 * Zoom the map so every point is on screen, clear of the docked left panel.
 * "Show on Map" for weather stations used to add pins only: the map stays zoomed
 * on the drone and the stations are 10 to 50 km away, so nothing seemed to happen.
 */
export function fitMapToPoints(points: readonly LatLng[]): void {
  const map = getMap();
  const valid = points.filter((p) => Number.isFinite(p.lat) && Number.isFinite(p.lng));
  if (!map || valid.length < 2) return;
  const bounds = new mapboxgl.LngLatBounds();
  for (const p of valid) bounds.extend([p.lng, p.lat]);
  // The left panel is docked from `lg` up (320 px at xl, 280 below); on a phone it is a sheet.
  const left = window.innerWidth >= 1280 ? 350 : window.innerWidth >= 1024 ? 310 : 60;
  map.fitBounds(bounds, {
    padding: { top: 90, bottom: 90, left, right: 70 },
    maxZoom: 13,
    duration: 600,
  });
}
